import { Injectable } from '@angular/core';
import { MyHttpClient } from '../http-client';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';

export interface VehicleIconOptions {
  orderType: string;
  pickupLat?: number;
  pickupLng?: number;
  userId?: string;
  appId?: string;
  appVersion?: string;
  roles?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ShareRideHomeService {
  server: string = environment.SERVER;
  trackUrl = process.env.SERVER + '/api/track/';

  constructor(private http: MyHttpClient) {}

  getTrackingData(trackId) {
    return this.http.get(this.trackUrl + trackId);
  }

  getVehicleIconUrl(options: VehicleIconOptions): Observable<string | null> {
    if (!options.orderType) return of(null);
    
    const url = this.buildVehicleIconUrl(options);
    const headers = this.buildRequestHeaders(options);
    
    return this.http.get(url, { headers }).pipe(
      map((response: any) => (response && response.iconUrl) ? response.iconUrl : null),
      catchError(() => of(null))
    );
  }

  private buildVehicleIconUrl(options: VehicleIconOptions): string {
    const params = new URLSearchParams();
    if (options.pickupLat != null && options.pickupLng != null) {
      params.set('pickupLat', String(options.pickupLat));
      params.set('pickupLng', String(options.pickupLng));
    }
    const queryString = params.toString() ? `?${params.toString()}` : '';
    return `${process.env.SERVER}/api/vehicle-icon/${encodeURIComponent(options.orderType)}${queryString}`;
  }

  private buildRequestHeaders(options: VehicleIconOptions): { [key: string]: string } {
    const headers: { [key: string]: string } = {};
    if (options.pickupLat != null) headers['latitude'] = String(options.pickupLat);
    if (options.pickupLng != null) headers['longitude'] = String(options.pickupLng);
    if (options.userId) headers['x-consumer-username'] = options.userId;
    if (options.appId) headers['appId'] = options.appId;
    if (options.appVersion) headers['appVersion'] = String(options.appVersion);
    if (options.roles) headers['roles'] = options.roles;
    return headers;
  }
}
